import React, { useContext } from 'react';
import _get from 'lodash/get';
import _size from 'lodash/size';

import { If } from 'utils';
import { UiKit, DispositionMode } from 'components';
import { RetexContext } from 'components/RetexDetails';
import { COMMENT_OPTIONS } from '../../stubs';

const KEYS = {
  MODE: 'disposition.mode',
  COMMENT: 'disposition.comment',
  CUSTOM_COMMENT: 'disposition.custom_comment'
};
const MAX_CHARS = 200;

export default function Disposition() {
  const {
    retex,
    orderService,
    isDisabled,
    isApproved,
    isRejected,
    isAwatitingAtAdmin,
    onUpdateRetex
  } = useContext(RetexContext);

  const dispositionMode = _get(retex, KEYS.MODE, null);
  const comment = _get(retex, KEYS.COMMENT, null);
  const customComment = _get(retex, KEYS.CUSTOM_COMMENT, '');
  const entityType = _get(retex, 'entity_type', '');
  const isLocked = _get(orderService, 'on_hold', false);

  const showCustomInput = _get(comment, 'value') === 'Other';
  const charactersUsed = _size(customComment);
  const isPurchase = entityType === 'PCH';
  const disableActions = isDisabled || isLocked || !isAwatitingAtAdmin;

  const onModeChange = mode => {
    onUpdateRetex({ disposition: { mode } });
  };

  const onSelectComment = comment => {
    onUpdateRetex({ disposition: { comment } });
  };

  const onCustomCommentChange = comment => {
    onUpdateRetex({ disposition: { custom_comment: comment } });
  };

  return (
    <If test={!isPurchase}>
      <UiKit.Grid templateColumns="1fr" gap="16">
        <UiKit.Grid templateColumns="1fr" gap="4">
          <UiKit.Title size="sm">Disposition</UiKit.Title>
          {isApproved || isRejected ? (
            <DispositionMode mode={dispositionMode} />
          ) : (
            <UiKit.Radio.Group
              value={dispositionMode}
              onChange={onModeChange}
              variant="inline"
              disabled={disableActions || isApproved || isRejected}
            >
              <UiKit.Radio.Option label="Restock" value="resale" />
              <UiKit.Radio.Option label="Don’t restock" value="scrap" />
            </UiKit.Radio.Group>
          )}
        </UiKit.Grid>
        <UiKit.Select
          isClearable
          label="Additional Comment"
          options={COMMENT_OPTIONS}
          value={comment}
          onChange={onSelectComment}
          isDisabled={disableActions}
          placeholder="Select a comment (Optional)"
        />
        <If test={showCustomInput}>
          <UiKit.Textarea
            autoFocus
            label="Enter your comment"
            value={customComment}
            onChange={onCustomCommentChange}
            maxLength={MAX_CHARS}
            disabled={disableActions}
            caption={`${charactersUsed} / ${MAX_CHARS} characters`}
          />
        </If>
      </UiKit.Grid>
    </If>
  );
}
